export const parseUrl = (url: string) => {
  if (
    /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(url) &&
    !url.toLowerCase().startsWith('mailto:')
  ) {
    // For emails, prepend "mailto:" to make it a valid mail link.
    return `mailto:${url}`;
  }

  if (!/^[a-zA-Z0-9+.-]+:/.test(url)) {
    // For links without a protocol (e.g., www.example.com), prepend "//" to make it a protocol-relative link.
    return `//${url}`;
  }

  // apparently already a valid url
  return url;
};
